import React from 'react'

import styled from 'styled-components'

import { ShareButton } from 'src/Components/Buttons/ShareButton'
import {
  LikeDislikeBlock,
  LikeDislikeButtonProps,
} from 'src/Components/LikeDislikeBlock'
import { Review } from 'src/Types/reviews'
import { SaveButton } from 'src/Components/Buttons/SaveButton'
import { ReviewTypeStatus } from 'src/Hooks/useCampaignDetailsReviews'

const ActionsBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

interface ReviewActionsProps {
  reviewStatus?: ReviewTypeStatus
  onSubmitLikeDislike?: LikeDislikeButtonProps['onSubmitLikeDislike']
  reviewId: number
  reviewComplain?: Review['artist_feedback_status']
  onShareClick: () => void
  onClickSave?: () => void
  isFavouriteCurator?: boolean
  onAddFavoriteCuratorLoading: boolean
}

export const ReviewActions: React.FC<ReviewActionsProps> = ({
  reviewStatus,
  onSubmitLikeDislike,
  reviewId,
  reviewComplain,
  onShareClick,
  onClickSave,
  isFavouriteCurator,
  onAddFavoriteCuratorLoading,
}) => {
  if (reviewStatus === 'awaiting' || reviewStatus === 'notReviewed') {
    return null
  }

  return (
    <ActionsBlock>
      {onSubmitLikeDislike && (
        <LikeDislikeBlock
          onSubmitLikeDislike={onSubmitLikeDislike}
          reviewId={reviewId}
          reviewComplain={reviewComplain ?? null}
        />
      )}
      <ShareButton onClick={onShareClick} data-testid='share-button' />
      {onClickSave && (
        <SaveButton
          isSaved={isFavouriteCurator}
          onClick={onClickSave}
          loading={onAddFavoriteCuratorLoading}
        />
      )}
    </ActionsBlock>
  )
}
